import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchProducers(organization_id, current_page, rows_per_page) {
    return RequesterV1.get(
      `organization/certifications/basic_certifications_producers/list_producers/${organization_id}/fetch_producers/${current_page}/${rows_per_page}`
    );
  },
  fetchCertifications(organization_id) {
    return RequesterV1.get(
      `organization/certifications/basic_certifications_producers/list_producers/${organization_id}/fetch_certifications`
    );
  },
  downloadReport(organization_id) {
    return RequesterV1.get(
      `organization/certifications/basic_certifications_producers/list_producers/${organization_id}/download_report`,
      { responseType: "blob" }
    );
  },
};
